module.exports = __webpack_public_path__ + "img/40_38_026_520.a8d72e7a.jpg";